import React from "react";

import { useScroll } from "@FillInTableContainer/components/FillInTable/hooks/useScroll";
import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";
import { useGetNumberOfTable } from "@FillInTableContainer/shared/hooks/useGetNumberOfTable";
import { isRequiredGroupTable } from "@FillInTableContainer/shared/utils/getOptionsFromData";
import { getGroupTableTitle } from "@FillInTableContainer/shared/utils/getTextFromData";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealsKeyCommentCreatorTable from "./components/DealsKeyCommentCreatorTable/DealsKeyCommentCreatorTable";
import DealsKeyCommentMaCreatorTable from "./components/DealsKeyCommentMaCreatorTable/DealsKeyCommentMaCreatorTable";
import {
  DEALS_KEY_COMMENT_GROUP_TABLE_LAYOUT,
  DEALS_MA_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT,
} from "./constants/dealsKeyCommentGroupTableLayout";
import * as S from "./DealsKeyCommentGroupTable.style";

const groupTableIndex = 3;

const maLayout = DEALS_MA_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT;
const nonMaLayout = DEALS_KEY_COMMENT_GROUP_TABLE_LAYOUT;

const DealsKeyCommentGroupTable = () => {
  const { isMergeAndAcquisition, isVentureFormation } =
    useCurrentDealTypeValue();
  const { register } = useScroll();
  const { tableCount } = useGetNumberOfTable();
  const articleSection = useArticleSection();

  const { checkDisableEdit } = useCanEditGroupTable();

  // M&A 와 VF 는 동일한 "Key Comment List"(복수) 구조를 공유한다.
  const isKeyCommentListLayout = isMergeAndAcquisition || isVentureFormation;

  const groupTableKey = isKeyCommentListLayout
    ? maLayout.groupTableKey
    : nonMaLayout.groupTableKey;

  return (
    <S.GroupTableWrapper
      isDisableEdit={checkDisableEdit(groupTableKey)}
      {...register(groupTableKey)}
    >
      <TableCreatorGroupTableTitle
        title={getGroupTableTitle(articleSection, groupTableKey)}
        isRequired={isRequiredGroupTable(articleSection, groupTableKey)}
      />
      <S.TableCreatorTableListWrapper
        isDisableEdit={checkDisableEdit(groupTableKey)}
      >
        {newArrayToCountValue(tableCount(groupTableKey)).map((_, tableIndex) =>
          isKeyCommentListLayout ? (
            <DealsKeyCommentMaCreatorTable
              key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
              tableKey={maLayout.tableList[0].tableKey}
              groupShellList={maLayout.tableList[0].groupShellList}
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              tableIndex={tableIndex}
            />
          ) : (
            <DealsKeyCommentCreatorTable
              key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
              tableKey={nonMaLayout.tableList[0].tableKey}
              groupShellList={nonMaLayout.tableList[0].groupShellList}
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              tableIndex={tableIndex}
              tableCount={tableCount(groupTableKey)}
            />
          ),
        )}
      </S.TableCreatorTableListWrapper>
    </S.GroupTableWrapper>
  );
};

export default DealsKeyCommentGroupTable;
